import { ReactNode } from 'react';
import styles from './AlertFooter.module.css';
import { LFC } from '../../types';

interface AlertFooterProps {
  children?: ReactNode;
}

export const AlertFooter: LFC<AlertFooterProps> = ({ children }) => {
  return <div className={styles.footer}>{children}</div>;
};
